module.exports = __webpack_public_path__ + "img/activity.97bc7968.svg";